import { AbconetApi } from '../General/AbconetApi';

export class AccountCompanySwitcher extends React.Component {

    setActiveAccount(account) {
        AbconetApi.post('/api/user/setactiveaccount', { accountId: account.accountId }).then(() => {
            window.location.href = '/';
        });
    }

    renderAccount(account) {
        return <button key={account.id} className="btn btn-link" onClick={this.setActiveAccount.bind(this, account)}>
            {account.accountName}
               </button>;
    }

    render() {

        return <div className="company-switcher">
            {this.props.member.otherAccountCollection.map(this.renderAccount.bind(this))}
               </div>;
    }
}